<div class="wrapper">
  <div class="frame">
    <i class="fas fa-times clickable" (click)="onClose()"></i>
    <div class="header">
      <span
        class="headerText"
        i18n="@@buildinglist.reassignaddress.title.existingbuilding"
        >existing <span class="bold">building</span></span
      >
    </div>
    <div class="body">
      <div class="section">
        <span
          class="sectionHeader"
          i18n="@@buildinglist.reassignaddress.title.buildinginfo"
          >Building info</span
        >
        <div class="addressFrame" [formGroup]="addressForm">
          <div class="addressHeaders">
            <span class="addressHeader" i18n="@@general.lomkey"
              >Building Key</span
            >
            <span class="addressHeader" i18n="@@general.street">Street</span>
            <span class="addressHeader" i18n="@@general.number.short">N°</span>
            <span class="addressHeader" i18n="@@general.suffix">Suffix</span>
            <span class="addressHeader" i18n="@@general.postalcode"
              >Postal Code</span
            >
            <span class="addressHeader" i18n="@@general.city">City</span>
          </div>
          <div class="inputs">
            <input class="" formControlName="lomKey" />
            <input formControlName="street" />
            <input formControlName="number" />
            <input formControlName="suffix" />
            <input formControlName="postalCode" />
            <input formControlName="city" />
          </div>
        </div>
      </div>
      <div class="section">
        <span
          class="sectionHeader"
          i18n="@@buildinglist.reassignaddress.header.existingbuilding"
          >Existing building</span
        >
        <div class="buildingList scrollbar">
          <div
            class="existingAddressFrame clickable"
            [class.selected]="selectedAddress?.addressId == address.addressId"
            *ngFor="let address of matchingAddresses"
            (click)="onSelectExistingBuilding(address)"
          >
            <div class="existingSection existingHeaders">
              <span class="addressHeader" i18n="@@general.lomkey"
                >Building Key</span
              >
              <span class="addressHeader" i18n="@@general.address"
                >Address</span
              >
            </div>
            <div class="existingSection">
              <span>{{ address.buildingLomKey }}</span>
              <span>{{ address.addressDisplayText }}</span>
            </div>
          </div>
        </div>
      </div>
      <img
        *ngIf="selectedAddress"
        class="saveBtn"
        src="assets/Keen&Wise_save.png"
        (click)="onSave()"
      />
    </div>
  </div>
</div>
